import {
  TSelectCsvSeperatorTranslations,
} from './select-csv-seperator.ts';

const options: TSelectCsvSeperatorTranslations = {
  comma: 'Čiarka',
  pipe: 'Zvislá čiara',
  semicolon: 'Bodkočiarka',
  space: 'Medzera',
  tab: 'Tabulátor',
};

export default {
  placeholder: '',
  label: 'Oddeľovač',
  options,
};
